import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "response"]

  connect() {
    // Expose the callback globally so reCAPTCHA can access it
    window.onRecaptchaSuccess = this.onRecaptchaSuccess.bind(this)
  }

  onRecaptchaSuccess(token) {
    this.responseTarget.value = token
    this.formTarget.submit()
  }
}
